import React from "react";
import { Text } from "@fluentui/react";
import DetailsTable from "../../../../Table/DetailsTable";

const truncate = (value, maxLength = 180) => {
    if (!value) {
        return "";
    }

    return value.length <= maxLength
        ? value
        : `${value.substring(0, maxLength).trimEnd()}...`;
};

const shouldPreferTranscript = (typeSlug) => {
    if (!typeSlug) {
        return false;
    }

    const normalizedTypeSlug = typeSlug.trim().toLowerCase();
    return (
        normalizedTypeSlug === "audio" ||
        normalizedTypeSlug === "infographics" ||
        normalizedTypeSlug === "videos" ||
        normalizedTypeSlug === "full-webinar-videos" ||
        normalizedTypeSlug === "webinar-clip-videos"
    );
};

const getContentTextDisplay = (item) => {
    if (shouldPreferTranscript(item?.typeSlug) && item?.transcript) {
        return item.transcript;
    }

    return item?.contentText || "";
};

const ContentSummariesTable = ({ items, loading, onSelectionChange }) => {
    const columns = [
        {
            key: "contentId",
            name: "Content ID",
            fieldName: "contentId",
            minWidth: 90,
            maxWidth: 110,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            key: "title",
            name: "Title",
            fieldName: "title",
            minWidth: 220,
            maxWidth: 320,
            isResizable: true,
            onRender: (item) => <Text>{item.title}</Text>,
        },
        {
            key: "typeSlug",
            name: "Content Type",
            fieldName: "typeSlug",
            minWidth: 100,
            maxWidth: 160,
            isResizable: true,
            onRender: (item) => <Text>{item.typeSlug || "—"}</Text>,
        },
        {
            key: "contentText",
            name: "Content Text",
            fieldName: "contentText",
            minWidth: 320,
            maxWidth: 460,
            isResizable: true,
            onRender: (item) => {
                const displayText = getContentTextDisplay(item);
                return (
                    <Text title={displayText}>
                        {truncate(displayText, 220)}
                    </Text>
                );
            },
        },
        {
            key: "effectiveSummary",
            name: "Summary",
            fieldName: "effectiveSummary",
            minWidth: 260,
            maxWidth: 420,
            isResizable: true,
            onRender: (item) => (
                <div title={item.effectiveSummary || ""}>
                    <Text>{item.effectiveSummary ? truncate(item.effectiveSummary, 180) : "No summary yet"}</Text>
                </div>
            ),
        },
    ];

    return (
        <DetailsTable
            items={items ?? []}
            columns={columns}
            selectionMode="multiple"
            selectionHook={onSelectionChange}
            loading={loading}
            hideFilterField={true}
            hideSelectionDetails={true}
            mainColumn="title"
            emptyStateMessage='No content matched your filters. Review the checkboxes above to ensure your results are not being left out.'
        />
    );
};

export default ContentSummariesTable;
